export default __webpack_public_path__ + "static/teamsImg4-317dc7351d8b8738767a6eb9ccc52641.webp";